/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Service_LabelInputs */

const en_form_service_label = /** @type {(inputs: Form_Service_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service`)
};

const ar_form_service_label = /** @type {(inputs: Form_Service_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الخدمة`)
};

const bn_form_service_label = /** @type {(inputs: Form_Service_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সেবা`)
};

const de_form_service_label = /** @type {(inputs: Form_Service_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service`)
};

const es_form_service_label = /** @type {(inputs: Form_Service_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Servicio`)
};

const fr_form_service_label = /** @type {(inputs: Form_Service_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service`)
};

const pt_form_service_label = /** @type {(inputs: Form_Service_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serviço`)
};

const zh_form_service_label = /** @type {(inputs: Form_Service_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`服务`)
};

const tr_form_service_label = /** @type {(inputs: Form_Service_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hizmet`)
};

const ru_form_service_label = /** @type {(inputs: Form_Service_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Услуга`)
};

const pl_form_service_label = /** @type {(inputs: Form_Service_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usługa`)
};

/**
* | output |
* | --- |
* | "Service" |
*
* @param {Form_Service_LabelInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const form_service_label = /** @type {((inputs?: Form_Service_LabelInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Service_LabelInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_form_service_label(inputs)
	if (locale === "bn") return bn_form_service_label(inputs)
	if (locale === "de") return de_form_service_label(inputs)
	if (locale === "es") return es_form_service_label(inputs)
	if (locale === "fr") return fr_form_service_label(inputs)
	if (locale === "pt") return pt_form_service_label(inputs)
	if (locale === "zh") return zh_form_service_label(inputs)
	if (locale === "tr") return tr_form_service_label(inputs)
	if (locale === "ru") return ru_form_service_label(inputs)
	if (locale === "pl") return pl_form_service_label(inputs)
	return en_form_service_label(inputs)
});